import React, {FC} from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../../../constants/colors';
import {FilterGroup} from '../Shared/GenericFilteredItems/FilterGroup';
import {GenericFilterItemGroup} from '../Shared/GenericFilteredItems/types';
import {useSelectedGroups} from '../Shared/helpers';

export interface Props {
  search: string;
  activeBrandIds: Array<string>;
  brandGroups: Array<GenericFilterItemGroup>;
  onBrandClick: (itemId: string, itemSlug?: string) => void;
}

export const SelectedBrands: FC<Props> = ({
  search,
  activeBrandIds,
  brandGroups,
  onBrandClick,
}) => {
  const selectedBrandGroup = useSelectedGroups({
    itemGroups: brandGroups,
    search,
    activeIds: activeBrandIds,
  });

  return (
    <SelectedBrandGroupContainer>
      {selectedBrandGroup && (
        <FilterGroup
          isFirstGroup={true}
          activeIds={activeBrandIds}
          onItemClick={onBrandClick}
          dataGroup={selectedBrandGroup}
          dataTestId={'SectionSelected'}
          key={`filter-flyout-brand-group-${selectedBrandGroup.groupLabel}`}
          enableFilterFlyout={false} // desktop version needs different styling
        />
      )}
    </SelectedBrandGroupContainer>
  );
};

const SelectedBrandGroupContainer = styled.div`
  border-bottom: 1px solid ${COLORS.Grey3};
`;
